/**
 * Private showroom shortlist. Separate from the bag and the wish list.
 * Up to five pieces are stored in this browser and prefilled into Calendly.
 */
(function () {
  var STORAGE_KEY = "orlumiere:showroom";
  var MAX = 5;
  var limitTimer = null;
  var calendlyTimer = null;
  var calendlyRequest = 0;
  var step = 1;
  var booked = false;
  var filter = "all";
  var BOOKED_KEY = "orlumiere:showroom:booked";

  function read() {
    try {
      var parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
      if (!Array.isArray(parsed)) return [];
      return parsed.filter(function (item) {
        return item && item.id && item.title;
      }).slice(0, MAX);
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, MAX)));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent("showroom:updated"));
  }

  function indexOf(items, id) {
    var key = String(id || "");
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].id) === key) return i;
    }
    return -1;
  }

  function productFromEl(el) {
    if (!el) return null;
    var id = String(el.getAttribute("data-product-id") || "");
    if (!id) return null;
    return {
      id: id,
      handle: el.getAttribute("data-product-handle") || "",
      title: el.getAttribute("data-product-title") || "",
      url: el.getAttribute("data-product-url") || "",
      image: el.getAttribute("data-product-image") || "",
      variantId: el.getAttribute("data-product-variant-id") || "",
      variantTitle: el.getAttribute("data-product-variant-title") || "",
      sku: el.getAttribute("data-product-sku") || "",
    };
  }

  function safeUrl(url) {
    if (!url) return "";
    try {
      var parsed = new URL(url, window.location.origin);
      if (parsed.protocol === "https:" || parsed.protocol === "http:") return parsed.href;
    } catch (e) {}
    return "";
  }

  function answerLine(item) {
    if (!item || !item.title) return "";
    var parts = [item.title];
    if (item.variantTitle && item.variantTitle !== "Default Title") parts.push(item.variantTitle);
    if (item.sku) parts.push("SKU " + item.sku);
    var url = safeUrl(item.url);
    if (url) parts.push(url);
    var line = parts.join(" — ");
    if (line.length <= 500) return line;
    return line.slice(0, 497) + "...";
  }

  function customAnswers(items) {
    var answers = {};
    for (var i = 0; i < MAX; i++) {
      answers["a" + (i + 1)] = answerLine(items[i]);
    }
    return answers;
  }

  function calendlyBase(url) {
    if (!url) return "";
    try {
      var parsed = new URL(url, window.location.origin);
      if (parsed.protocol !== "https:") return "";
      var host = parsed.hostname.toLowerCase();
      if (host !== "calendly.com" && host.slice(-13) !== ".calendly.com") return "";
      return parsed.origin + parsed.pathname.replace(/\/$/, "");
    } catch (e) {
      return "";
    }
  }

  function calendlyHref(base, items) {
    var url = new URL(base);
    var answers = customAnswers(items);
    Object.keys(answers).forEach(function (key) {
      if (answers[key]) url.searchParams.set(key, answers[key]);
    });
    return url.toString();
  }

  function fillCount(template, count) {
    return String(template || "").replace("__COUNT__", String(count));
  }

  function syncButtons() {
    var items = read();
    document.querySelectorAll("[data-showroom-toggle]").forEach(function (btn) {
      var on = indexOf(items, btn.getAttribute("data-product-id")) >= 0;
      btn.setAttribute("aria-pressed", on ? "true" : "false");
      var label = on ? btn.getAttribute("data-label-remove") : btn.getAttribute("data-label-add");
      var target = btn.querySelector("[data-showroom-toggle-label]") || btn;
      if (label) target.textContent = label;
      var card = btn.closest("[data-showroom-card]");
      if (card) card.classList.toggle("is-selected", on);
    });
  }

  function thumb(item, className) {
    var media = document.createElement("span");
    media.className = className;
    var imageUrl = safeUrl(item && item.image);
    if (imageUrl) {
      var img = document.createElement("img");
      img.alt = "";
      img.loading = "lazy";
      img.src = imageUrl;
      media.appendChild(img);
    }
    return media;
  }

  function renderTray() {
    var page = document.querySelector("[data-showroom-page]");
    if (!page) return;
    var items = read();
    var list = page.querySelector("[data-showroom-list]");
    var empty = page.querySelector("[data-showroom-empty]");
    var countEl = page.querySelector("[data-showroom-count]");
    if (empty) empty.hidden = items.length > 0;
    if (countEl) {
      countEl.textContent = fillCount(page.getAttribute("data-count-template"), items.length);
    }
    if (!list) return;
    list.innerHTML = "";
    var removeLabel = page.getAttribute("data-remove-label") || "Remove";
    for (var i = 0; i < MAX; i++) {
      var item = items[i];
      var li = document.createElement("li");
      li.className = "showroom-tray__slot" + (item ? " is-filled" : "");
      if (item) {
        li.appendChild(thumb(item, "showroom-tray__thumb"));
        li.title = item.title;
        var remove = document.createElement("button");
        remove.type = "button";
        remove.className = "showroom-tray__remove";
        remove.setAttribute("data-showroom-remove", "");
        remove.setAttribute("data-product-id", item.id);
        remove.setAttribute("aria-label", removeLabel + ": " + item.title);
        remove.textContent = "×";
        li.appendChild(remove);
      } else {
        var num = document.createElement("span");
        num.className = "showroom-tray__num";
        num.textContent = String(i + 1);
        li.appendChild(num);
      }
      list.appendChild(li);
    }
  }

  function renderBar() {
    var bar = document.querySelector("[data-showroom-bar]");
    if (!bar) return;
    var onShowroom = document.body.classList.contains("template-page-showroom");
    var items = read();
    var show = items.length > 0 && !onShowroom;
    bar.hidden = !show;
    document.body.classList.toggle("has-showroom-bar", show);
    var link = bar.querySelector("[data-showroom-bar-link]");
    if (link) {
      link.textContent = fillCount(link.getAttribute("data-label-template"), items.length);
    }
  }

  function showLimit() {
    var notes = document.querySelectorAll("[data-showroom-limit]");
    if (!notes.length) return;
    Array.prototype.forEach.call(notes, function (note) {
      note.hidden = false;
    });
    clearTimeout(limitTimer);
    limitTimer = setTimeout(function () {
      Array.prototype.forEach.call(notes, function (note) {
        note.hidden = true;
      });
    }, 4000);
  }

  function toggleProduct(product) {
    var items = read();
    var idx = indexOf(items, product.id);
    if (idx >= 0) {
      items.splice(idx, 1);
      write(items);
      return { removed: true };
    }
    if (items.length >= MAX) return { limited: true };
    items.push(product);
    write(items);
    return { added: true };
  }

  function removeProduct(id) {
    var items = read();
    var idx = indexOf(items, id);
    if (idx < 0) return;
    items.splice(idx, 1);
    write(items);
  }

  function variantImage(variant) {
    if (!variant) return "";
    var featured = variant.featured_image;
    if (featured && typeof featured === "object" && featured.src) return featured.src;
    if (typeof featured === "string") return featured;
    var media = variant.featured_media;
    if (media && media.preview_image && media.preview_image.src) return media.preview_image.src;
    return "";
  }

  function variantLabel(variant) {
    if (!variant) return "";
    var title = variant.public_title || variant.title || "";
    if (!title || title === "Default Title") return "";
    return title;
  }

  function applyVariant(variant) {
    if (!variant) return;
    var btn = document.querySelector("[data-product-section] [data-showroom-toggle]");
    if (!btn) return;
    var label = variantLabel(variant);
    btn.setAttribute("data-product-variant-id", variant.id ? String(variant.id) : "");
    btn.setAttribute("data-product-variant-title", label);
    btn.setAttribute("data-product-sku", variant.sku || "");
    var base = btn.getAttribute("data-product-base-url") || "";
    if (base && variant.id) btn.setAttribute("data-product-url", base + "?variant=" + variant.id);
    var image = variantImage(variant);
    if (image) btn.setAttribute("data-product-image", image);

    var items = read();
    var idx = indexOf(items, btn.getAttribute("data-product-id"));
    if (idx < 0) return;
    var next = Object.assign({}, items[idx], productFromEl(btn));
    items[idx] = next;
    write(items);
  }

  function ensureCalendly(done) {
    if (window.Calendly && window.Calendly.initInlineWidget) {
      done();
      return;
    }
    var existing = document.querySelector('script[data-showroom-calendly-script]');
    if (existing) {
      existing.addEventListener("load", done);
      return;
    }
    var script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    script.setAttribute("data-showroom-calendly-script", "");
    script.addEventListener("load", done);
    document.head.appendChild(script);
  }

  function mountCalendly() {
    var page = document.querySelector("[data-showroom-page]");
    if (!page) return;
    var request = ++calendlyRequest;
    var base = calendlyBase(page.getAttribute("data-calendly-url") || "");
    var items = read();
    var link = page.querySelector("[data-showroom-calendly-link]");
    var parent = page.querySelector("[data-showroom-calendly]");
    var pending = page.querySelector("[data-showroom-calendly-pending]");
    var fallback = page.querySelector("[data-showroom-calendly-fallback]");
    if (!base) {
      if (parent) parent.hidden = true;
      if (fallback) fallback.hidden = true;
      if (pending) pending.hidden = false;
      return;
    }
    if (link) link.href = calendlyHref(base, items);
    if (pending) pending.hidden = true;
    if (fallback) fallback.hidden = false;
    if (parent) parent.hidden = false;
    if (!parent) return;
    ensureCalendly(function () {
      if (request !== calendlyRequest) return;
      if (!window.Calendly || !window.Calendly.initInlineWidget) return;
      parent.innerHTML = "";
      window.Calendly.initInlineWidget({
        url: base,
        parentElement: parent,
        prefill: { customAnswers: customAnswers(read()) },
      });
    });
  }

  function scheduleCalendly() {
    if (step !== 2) return;
    if (!document.querySelector("[data-showroom-page]")) return;
    clearTimeout(calendlyTimer);
    calendlyTimer = setTimeout(mountCalendly, 200);
  }

  function renderRecap() {
    var items = read();
    document.querySelectorAll("[data-showroom-recap]").forEach(function (list) {
      list.innerHTML = "";
      items.forEach(function (item) {
        var li = document.createElement("li");
        li.className = "showroom-recap__item";
        li.appendChild(thumb(item, "showroom-recap__thumb"));
        var copy = document.createElement("span");
        copy.className = "showroom-recap__copy";
        var title = document.createElement("span");
        title.className = "showroom-recap__title";
        title.textContent = item.title;
        copy.appendChild(title);
        if (item.variantTitle && item.variantTitle !== "Default Title") {
          var meta = document.createElement("span");
          meta.className = "showroom-recap__meta";
          meta.textContent = item.variantTitle;
          copy.appendChild(meta);
        }
        li.appendChild(copy);
        list.appendChild(li);
      });
    });
  }

  function syncContinue() {
    var page = document.querySelector("[data-showroom-page]");
    if (!page) return;
    var count = read().length;
    var btn = page.querySelector("[data-showroom-continue]");
    if (btn) btn.disabled = count < 1;
    var status = page.querySelector("[data-showroom-next-status]");
    if (status) status.hidden = count > 0;
    page.classList.toggle("has-pieces", count > 0);
    var step2 = page.querySelector('[data-showroom-step-tab="2"]');
    if (step2) step2.disabled = count < 1;
    var step3 = page.querySelector('[data-showroom-step-tab="3"]');
    if (step3) step3.disabled = !booked;
  }

  function applyStep(next, scroll) {
    var items = read();
    if (next === 2 && items.length < 1) return;
    if (next === 3 && !booked) return;
    step = next;
    var page = document.querySelector("[data-showroom-page]");
    if (!page) return;
    page.setAttribute("data-showroom-step", String(step));
    page.querySelectorAll("[data-showroom-panel]").forEach(function (panel) {
      panel.hidden = panel.getAttribute("data-showroom-panel") !== String(step);
    });
    page.querySelectorAll("[data-showroom-step-tab]").forEach(function (tab) {
      var n = Number(tab.getAttribute("data-showroom-step-tab"));
      var current = n === step;
      tab.classList.toggle("is-current", current);
      tab.classList.toggle("is-complete", n < step);
      if (current) tab.setAttribute("aria-current", "step");
      else tab.removeAttribute("aria-current");
    });
    syncContinue();
    if (step === 2) scheduleCalendly();
    if (scroll) {
      var anchor = page.querySelector(".showroom-steps") || page;
      if (anchor.scrollIntoView) anchor.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  function cardMatches(card, filter) {
    if (filter === "all") return true;
    var cats = (card.getAttribute("data-showroom-categories") || "").split(/\s+/);
    return cats.indexOf(filter) >= 0;
  }

  function applyFilter() {
    var page = document.querySelector("[data-showroom-page]");
    if (!page) return;
    var bar = page.querySelector("[data-showroom-filters]");
    var cards = page.querySelectorAll("[data-showroom-grid] [data-showroom-card]");
    if (!bar) return;
    var buttons = bar.querySelectorAll("[data-showroom-filter]");
    var visibleTabs = 0;
    Array.prototype.forEach.call(buttons, function (btn) {
      var key = btn.getAttribute("data-showroom-filter");
      var count = 0;
      Array.prototype.forEach.call(cards, function (card) {
        if (cardMatches(card, key)) count++;
      });
      var countEl = btn.querySelector("[data-showroom-filter-count]");
      if (countEl) countEl.textContent = String(count);
      if (key !== "all") {
        btn.hidden = count === 0;
        if (count) visibleTabs++;
      }
      if (key === filter && count === 0) filter = "all";
    });
    bar.hidden = visibleTabs === 0;
    Array.prototype.forEach.call(buttons, function (btn) {
      var on = btn.getAttribute("data-showroom-filter") === filter;
      btn.classList.toggle("is-active", on);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
    });
    Array.prototype.forEach.call(cards, function (card) {
      card.hidden = !cardMatches(card, filter);
    });
  }

  function render() {
    syncButtons();
    renderTray();
    renderRecap();
    renderBar();
    syncContinue();
    if (step === 2 && read().length < 1) applyStep(1, false);
    else if (step === 2) scheduleCalendly();
  }

  function loadMore(btn) {
    var nextUrl = btn.getAttribute("data-next-url");
    var sectionId = btn.getAttribute("data-section-id");
    var grid = document.querySelector("[data-showroom-grid]");
    if (!nextUrl || !sectionId || !grid || btn.disabled) return;
    var defaultText = btn.textContent;
    btn.disabled = true;
    btn.textContent = btn.getAttribute("data-loading-text") || defaultText;
    var fetchUrl = nextUrl + (nextUrl.indexOf("?") >= 0 ? "&" : "?") + "section_id=" + encodeURIComponent(sectionId);
    fetch(fetchUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var newPage = doc.querySelector("[data-showroom-page]");
        if (!newPage) throw new Error("Showroom section missing");
        var newGrid = newPage.querySelector("[data-showroom-grid]");
        var newBtn = newPage.querySelector("[data-showroom-load-more]");
        if (newGrid) {
          Array.prototype.forEach.call(newGrid.children, function (child) {
            grid.appendChild(child);
          });
        }
        syncButtons();
        applyFilter();
        if (newBtn && newBtn.getAttribute("data-next-url")) {
          btn.disabled = false;
          btn.textContent = defaultText;
          btn.setAttribute("data-next-url", newBtn.getAttribute("data-next-url"));
        } else if (btn.parentNode) {
          btn.parentNode.remove();
        }
      })
      .catch(function () {
        window.location.href = nextUrl;
      });
  }

  document.addEventListener("click", function (e) {
    var toggle = e.target.closest && e.target.closest("[data-showroom-toggle]");
    if (toggle) {
      e.preventDefault();
      var product = productFromEl(toggle);
      if (!product) return;
      var result = toggleProduct(product);
      if (result.limited) showLimit();
      return;
    }
    var remove = e.target.closest && e.target.closest("[data-showroom-remove]");
    if (remove) {
      e.preventDefault();
      removeProduct(remove.getAttribute("data-product-id"));
      return;
    }
    var filterBtn = e.target.closest && e.target.closest("[data-showroom-filter]");
    if (filterBtn) {
      e.preventDefault();
      filter = filterBtn.getAttribute("data-showroom-filter") || "all";
      applyFilter();
      return;
    }
    var more = e.target.closest && e.target.closest("[data-showroom-load-more]");
    if (more) {
      e.preventDefault();
      loadMore(more);
      return;
    }
    var cont = e.target.closest && e.target.closest("[data-showroom-continue]");
    if (cont) {
      e.preventDefault();
      if (!cont.disabled) applyStep(2, true);
      return;
    }
    var back = e.target.closest && e.target.closest("[data-showroom-back]");
    if (back) {
      e.preventDefault();
      applyStep(1, true);
      return;
    }
    var tab = e.target.closest && e.target.closest("[data-showroom-step-tab]");
    if (tab && !tab.disabled) {
      e.preventDefault();
      applyStep(Number(tab.getAttribute("data-showroom-step-tab")), true);
    }
  });

  window.addEventListener("message", function (e) {
    var data = e.data || {};
    if (data.event !== "calendly.event_scheduled") return;
    if (String(e.origin || "").indexOf("calendly.com") === -1) return;
    booked = true;
    try {
      sessionStorage.setItem(BOOKED_KEY, "1");
    } catch (err) {}
    applyStep(3, true);
  });

  function restoreBooking() {
    var page = document.querySelector("[data-showroom-page]");
    if (!page) return;
    var wasBooked = false;
    try {
      wasBooked = sessionStorage.getItem(BOOKED_KEY) === "1";
    } catch (err) {}
    if (!wasBooked) return;
    booked = true;
    var returned =
      /[?&]customer_posted=true/.test(window.location.search) ||
      page.querySelector("[data-showroom-newsletter-success], [data-showroom-newsletter-error]");
    if (!returned) {
      syncContinue();
      return;
    }
    applyStep(3, false);
    var target = page.querySelector("#ShowroomNewsletter");
    if (target && target.scrollIntoView) {
      setTimeout(function () {
        target.scrollIntoView({ block: "center" });
      }, 50);
    }
  }

  document.addEventListener("variant:change", function (e) {
    var detail = e.detail || {};
    applyVariant(detail.variant);
  });

  document.addEventListener("showroom:updated", function () {
    render();
  });

  function init() {
    render();
    applyFilter();
    restoreBooking();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
